import { render, staticRenderFns } from "./collections.vue?vue&type=template&id=4a0a2cd1&"
import script from "./collections.vue?vue&type=script&lang=js&"
export * from "./collections.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports